import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
  title: string;
  children: ReactNode;
  actions: ReactNode;
  onClose: () => void;
  /** Širší varianta pro obsah s tabulkami (např. historie verzí a diff). */
  wide?: boolean;
}

/**
 * Epic 15, E15-US4 — portál do `document.body`, stejný důvod jako u
 * `ContextMenu.tsx` (viz jeho komentář): `SyncPanel`/`ChangeScriptPanel`/
 * `CreateScriptPanel` teď mohou být vyvolané zevnitř `CanvasToolsMenu`, jehož
 * vlastní portálovaný wrapper se zavírá přepínáním CSS viditelnosti, ne
 * odmountováním (aby se rozjetá akce nezrušila zavřením menu) — bez portálu
 * by `display: none` na tom wrapperu smazalo i tenhle modal, i když zůstává
 * "otevřený". Beze změny chování pro všechna ostatní dosavadní použití
 * (žádné z nich nezáviselo na konkrétním místě v DOM stromu, jen na
 * `position: fixed`).
 */
export function Modal({ title, children, actions, onClose, wide }: ModalProps) {
  return createPortal(
    <div
      className="modal-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className={`modal${wide ? ' modal--wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
        <h2>{title}</h2>
        {children}
        <div className="modal__actions">{actions}</div>
      </div>
    </div>,
    document.body,
  );
}
